import type { ReactNode } from 'react';
import { Box, Divider, Grid, Stack, Typography } from '@mui/material';

export interface DetailSectionProps {
  title?: ReactNode;
  /** Başlık satırının sağ ucundaki aksiyonlar. */
  actions?: ReactNode;
  children: ReactNode;
  /** İçerik bir `<Grid container>` mı olsun? `<DetailField>` kullanılıyorsa evet
   *  (varsayılan). Serbest içerik için `false`. */
  grid?: boolean;
  /** Bölümün altına ayraç. */
  divider?: boolean;
}

/** Detay sayfası bölümü — başlık + `<DetailField>` gridi. Kartların içinde ya da
 *  `<DetailPageLayout>` altında yığılır. */
export function DetailSection({ title, actions, children, grid = true, divider = false }: DetailSectionProps) {
  return (
    <Box sx={{ py: 1 }}>
      {(title || actions) && (
        <Stack
          direction="row"
          sx={{ alignItems: 'center', justifyContent: 'space-between', mb: 1.5, gap: 1 }}
        >
          {title && (
            <Typography variant="subtitle1" component="h2">
              {title}
            </Typography>
          )}
          {actions && <Box sx={{ flexShrink: 0 }}>{actions}</Box>}
        </Stack>
      )}
      {grid ? (
        <Grid container spacing={2}>
          {children}
        </Grid>
      ) : (
        children
      )}
      {divider && <Divider sx={{ mt: 2 }} />}
    </Box>
  );
}
